import classnames from 'classnames';
import React from 'react';
import { BodyStyle } from './bodyStylesList';
import { useInputContext } from '../../../context/InputContext';
import DefaultSuggestionClicked from '../../../contracts/DefaultSuggestionClicked';
import { useSearchBarContext } from '../../../SearchBarContext';
import SuggestionLink from '../SuggestionLink';

type BodyStyleTileProps = {
  bodyStyle: BodyStyle;
  handleDefaultSuggestionClicked: DefaultSuggestionClicked;
  isViewAllTile?: boolean;
  width: number;
};

export default function BodyStyleTile({
  bodyStyle,
  handleDefaultSuggestionClicked,
  isViewAllTile = false,
  width
}: BodyStyleTileProps) {
  const { inputValue } = useInputContext();
  const { cdnBaseUrl } = useSearchBarContext();

  return (
    <SuggestionLink
      className={classnames(
        'flex w-full flex-col items-center gap-4 rounded-[6px] border border-grey-1 bg-grey-1 p-8 transition-colors hover:border-blue-6',
        {
          'hidden m:flex': isViewAllTile
        }
      )}
      data-analytics-id="Default Suggestions"
      data-analytics-attributes={JSON.stringify({
        category: 'Vehicle Styles',
        label: bodyStyle.text,
        textEntered: inputValue
      })}
      data-qa="Default Search Bodystyles"
      defaultSuggestion={bodyStyle}
      handleDefaultSuggestionClicked={handleDefaultSuggestionClicked}
      style={{ minWidth: width }}
    >
      <img
        alt={bodyStyle.text}
        className={classnames('max-w-full', {
          'mt-auto flex w-fit rounded-full bg-white p-[10px]': isViewAllTile
        })}
        src={`${cdnBaseUrl}${bodyStyle.image}`}
      />
      <div className="w-full overflow-hidden text-ellipsis  whitespace-nowrap text-center text-blue-6 tl-body-s">
        {bodyStyle.text}
      </div>
    </SuggestionLink>
  );
}
